import styles from './FJArcProgress.module.less';
import { useEffect, useRef } from 'react';
import classNames from 'classnames';
function FJArcProgress(props) {
    const { boxClassName, percent, valueClassName, fractionDigits = 1, isShowPercent = true } = props;
    const progressRef = useRef(null);
    let progress = Math.min(100, percent * 100);

    useEffect(() => {
        progressRef.current.style.setProperty('--percent', progress);
    }, [progress]);

    return (
        <div className={classNames(styles.progress_circle, boxClassName)} ref={progressRef}>
            <svg>
                <circle className={styles.circle_bottom} stroke='var(--inactive-color)' />
                <circle className={styles.circle_top} />
            </svg>
            {isShowPercent ? (
                <div className={classNames(styles.circle_text, valueClassName)}>
                    {(Math.floor(progress * 10) / 10).toFixed(fractionDigits)}%
                </div>
            ) : null}
        </div>
    );
}

export default FJArcProgress;
